import { InvalidFormatError } from '../../common';
import { TransactionBaseModel } from './TransactionBaseModel';
import { TransactionTypeModel } from './TransactionTypeModel';
export class ClaimTransactionModel extends TransactionBaseModel {
    constructor({ version, attributes, inputs, outputs, scripts, hash, claims, }) {
        super({
            version,
            type: TransactionTypeModel.Claim,
            attributes,
            inputs,
            outputs,
            scripts,
            hash,
        });
        this.claims = claims;
        if (this.version !== 0) {
            throw new InvalidFormatError(`expected version 0, found: ${this.version}`);
        }
        if (this.claims.length === 0) {
            throw new InvalidFormatError('expected claims, found none.');
        }
    }
    clone({ scripts = this.scripts, attributes = this.attributes, inputs = this.inputs, outputs = this.outputs, }) {
        return new this.constructor({
            version: this.version,
            attributes,
            inputs,
            outputs,
            scripts,
            claims: this.claims,
        });
    }
    serializeExclusiveBase(writer) {
        writer.writeArray(this.claims, (claim) => {
            claim.serializeWireBase(writer);
        });
    }
}

//# sourceMappingURL=ClaimTransactionModel.js.map
